import { render, staticRenderFns } from "./listitem.component.vue?vue&type=template&id=2abdd1f4&scoped=true&"
import script from "./listitem.component.vue?vue&type=script&lang=ts&"
export * from "./listitem.component.vue?vue&type=script&lang=ts&"
import style0 from "./listitem.component.vue?vue&type=style&index=0&id=2abdd1f4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2abdd1f4",
  null
  
)

export default component.exports